import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=63d9f2e8&scoped=true"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"
import style0 from "./Notification.vue?vue&type=style&index=0&id=63d9f2e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d9f2e8",
  null
  
)

export default component.exports